// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"1c936176","108":"2eb5960e","183":"d8350005","532":"75a7016f","748":"896fe64a"}[chunkId] + ".chunk.css";
};